<template>
  <div class="fs12">
    <div @click="copyText(localData.id)">id: {{ localData.id }}</div>
    <div>状态: {{ localData.status }}</div>
    <div @click="copyText(localData.phone)">{{ localData.phone }}</div>

    <el-button type="primary" size="mini" @click="change_user_blance(localData)">余额调整</el-button>

    <el-dialog :visible.sync="balanceOperation.pop" width="500px">
      <el-form label-width="100px" label-position="right">
        <el-form-item :label="item.name" v-for="(item, index) in balanceOperation.from" :key="index" :required="item.required">
          <XInput v-model="balanceOperation.data[item.key]" :disabled="item.disabled" :type="item.type" :options="item.options"> </XInput>
        </el-form-item>

        <el-form-item>
          <el-button size="small" @click="changeUserBalanceFunc(balanceOperation.data)">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import {changeUserBalance} from '@/api/api'
  export default {
    props: {
      value: {
        type: null,
        default: null
      }
    },

    data() {
      return {
        localData: null,
        balanceOperation: {
          pop: false,
          index: 0,
          data: {},
          from: [
            {name: '用户id', key: 'id', disabled: true},
            {name: '当前余额', key: 'balance', disabled: true},
            {
              name: '变动类型',
              key: 'event',
              type: 'select',

              options: [
                {label: '增加', value: '增加'},
                {label: '减少', value: '减少'}
              ]
            },
            {name: '金额', key: 'money', type: 'number'},

            {name: '备注', key: 'change_remark'}
          ]
        }
      }
    },

    created() {
      this.localData = this.value
    },
    methods: {
      copyText(text) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.$message.success('文本已复制')
          })
          .catch(err => {
            this.$message.error('复制失败')
          })
      },
      change_user_blance(data) {
        this.balanceOperation.data = data
        this.balanceOperation.index += 1
        this.balanceOperation.pop = true
      },
      changeUserBalanceFunc(data) {
        changeUserBalance(data).then(res => {
          if (res.code == 200) {
            // this.$refs.table.Search()
            this.balanceOperation.pop = false
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped></style>
